import PatientDetailAttending from "@/components/census/PatientDetailAttending";
import AlertsIcon from "@/components/shared/AlertsIcon";
import { patientNamespace } from "@/store/modules/patient";
import { CensusData } from "@/store/modules/patient/types";
import { CaseState } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

const CHECKMARK_SLOT = 99;
@Component({
  components: { PatientDetailAttending, AlertsIcon }
})
export default class ListCard extends Vue {
  @Getter("caseState", patientNamespace)
  caseStates!: Array<CaseState>;

  @Getter("towerMode", patientNamespace)
  towerMode!: boolean;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("now", patientNamespace)
  now: any;

  @Prop(Object)
  data!: CensusData;

  get sortedIcons() {
    return this.data.alert.slice().sort((a, b) => {
      if (a.atom === "caseReview") {
        return -1;
      } else if (b.atom === "caseReview") {
        return 1;
      } else {
        return 0;
      }
    });
  }

  get filteredAlerts() {
    return this.data.alert
      .filter(alert => {
        if (this.towerMode) {
          return alert.pickID !== "";
        } else {
          return true;
        }
      })
      .sort((a, b) => {
        const level = b.level - a.level;
        if (level == 0) {
          return a.id.localeCompare(b.id);
        }
        return level;
      });
  }

  get isICU() {
    return this.area == "awicu";
  }

  get isOR() {
    return this.area == "awor";
  }

  get isPACU() {
    return this.area == "awpacu";
  }

  getAbbrev(caseStateIndex: number) {
    return this.caseStates[caseStateIndex].abbrev;
  }

  get towerCheckMark() {
    if (!this.data.alert) {
      return false;
    }

    const checkMarks = this.data.alert.filter(alert => {
      return alert.slot === CHECKMARK_SLOT;
    });

    if (checkMarks.length) {
      return checkMarks[0].icon;
    } else {
      return false;
    }
  }
}
